export default __webpack_public_path__ + "static/logo-mobile-31074c11b0d1f6059edb413b50930149.png";